import React from 'react';

import { Button } from 'components/ui/button';
import { buildGrantUrl } from './helpers';
import { faPlugCircleBolt } from '@fortawesome/pro-regular-svg-icons';

import type { Grant, ProviderName } from '../types';

interface Props {
  grant: Grant | null;
  label: string;
  icon: string;
  path: string;
  providerName: ProviderName;
  scopes: string[];
}

export default function ConnectNylasGrant({ grant, icon, label, path, providerName, scopes }: Props) {
  const onClick = () => window.location.assign(buildGrantUrl(path, providerName, scopes));

  if (grant) {
    return <Button icon={faPlugCircleBolt} label="Reconnect" variant="ghost" onClick={onClick} />;
  } else {
    return (
      <Button className="gap-2" variant="outline" onClick={onClick}>
        <img src={icon} style={{ width: 16, height: 16 }} />
        Sign In with {label}
      </Button>
    );
  }
}
